import React from "react";

const NotFoundPage: React.FC = () => {
  return <>404</>;
};

export default NotFoundPage;
